import { render, staticRenderFns } from "./IconApi.vue?vue&type=template&id=090832b4"
import script from "./IconApi.vue?vue&type=script&lang=js"
export * from "./IconApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports